<template>
    <v-row justify="center" class="ma-0 pa-0">
        <v-col cols="12" xl="11" lg="11" md="12" sm="12">

            <v-row justify="center" no-gutters>
                <span class="text-h4 text-md-h3 font-weight-light">Settings</span>
            </v-row>

            <v-form ref="form" v-model="formValid">
                <v-row justify="center" align="center" no-gutters class="my-4">
                    <v-col cols="12" align="center" class="ma-0 pa-0">
                        <v-avatar size="120" :rules="profileImageRules" style="cursor: pointer;" @click.stop="openProfileImageFile()">
                            <v-img :src="!previewImage && userProfilePic != null ? userProfilePic : previewImage ? previewImage : require('../assets/no-user.png')"></v-img>
                            <v-overlay absolute :opacity="!profileImageError ? '.50' : '1'" :color="profileImageError ? 'red': 'grey darken-4'" style="z-index: 1;">
                                <v-icon>{{(!previewImage && !profileImageError) ? 'mdi-image-edit' : 'mdi-file-image-remove'}}</v-icon>
                                <v-file-input v-model="formData.imageInput" ref="fileInput" type="file" accept="image/*" @change="getProfileImageFile()" style="display: none;"/>
                            </v-overlay>
                        </v-avatar>
                    </v-col>
                    <v-col v-if="profileImageError" align="center" cols="12">
                        <span :class="profileImageError ? 'red--text' : 'transparent--text'" class="text-caption font-weight-light ma-0 pa-0" style="cursor: default;">*Image file must be less than 6 MB.</span>
                    </v-col>
                </v-row>

                <v-row justify="center" no-gutters class="mb-2">
                    <v-col cols="10" xl="4" lg="4" md="6" sm="8" align="center">
                            <div v-if="!showEditUsername" class="username-wrap text-h5" @click.stop="showEditUsername = !showEditUsername">
                                <span class="username-text" @click.stop="showEditUsername = !showEditUsername">{{ formData.username || username }}</span>
                                <v-btn icon small :ripple="false" class="rename-btn" @click.stop="showEditUsername = !showEditUsername">
                                    <v-icon color="primary">mdi-rename</v-icon>
                                </v-btn>
                            </div>
                            <!-- @input="(userDataChanged && newUsername === '') ? userDataChanged = false : null" -->
                            <!-- @click:append="showEditUsername = false" @blur="showEditUsername = false" @keypress.enter="showEditUsername = false" -->
                            <v-text-field v-else v-model.trim="formData.username" ref="usernameTextInput" counter="50" clearable outlined append-outer-icon="mdi-pencil-plus" :placeholder="username" :rules="usernameRules" @click:clear="formData.username = ''" @click:append-outer="validateUsername" @blur="validateUsername" @keypress.enter="validateUsername"></v-text-field>
                    </v-col>
                </v-row>

                <v-row justify="center" no-gutters class="mb-4">
                    <v-col cols="12" xl="4" lg="4" md="6" sm="8" align="center">
                        <span class=" text-body-2 font-italic accent--text">{{ email }}</span>
                    </v-col>
                </v-row>

                <v-row justify="center" no-gutters>
                    <v-col cols="12" xl="4" lg="4" md="6" sm="8">

                        <v-divider/>
                        <v-row justify="space-around" align="center" no-gutters>
                            <span class="mr-5">Theme: <v-icon class="theme-icon">mdi-theme-light-dark</v-icon></span>
                            <v-switch v-model="formData.darkTheme" inset color="primary" @change="$vuetify.theme.dark = !$vuetify.theme.dark;"></v-switch>
                        </v-row>
                        <v-divider class="pb-8"/>

                        <v-autocomplete v-model="formData.languageSelected" label="Select default language" :items="$languageCodes" item-text="text" item-value="value" return-object outlined hint="*Default langauge selected when creating a post" persistent-hint class="px-10" @change="languageChanged(formData.languageSelected.text, formData.languageSelected.value)"></v-autocomplete>
                        <v-divider class="pb-8"/>

                        <!-- ADVANCED SETTINGS -->
                        <v-row justify="center" align="center" class="pb-8">
                            <span text @click.stop="advancedShow = !advancedShow" style="cursor:pointer;" class="font-weight-light accent--text">Advanced Settings</span>
                            <v-btn icon @click="advancedShow = !advancedShow" :ripple="false"><v-icon>{{ advancedShow ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon></v-btn>
                        </v-row>


                        <!--
                        
                        
                        
                        -->
                        <v-row v-if="advancedShow" justify="center" no-gutters class="pb-0 pb-sm-8">
                        <!--
                        
                        
                        
                        -->
                            <v-col cols="12" xl="8" lg="8" md="10" sm="10" justify="center" align="center" class="ma-0 pa-0">
                                <v-divider class="pb-2"/>

                                <v-divider class="mx-10"/>
                                <v-row justify="space-between" align="center" no-gutters class="mx-10 mx-sm-0">
                                    <v-col cols="12" justify="center" align="center" class="ma-0 pa-0">
                                        <span class="text-h6 font-weight-light">Creation Settings</span>
                                    </v-col>
                                </v-row>

                                <v-divider/>
                                <v-row justify="space-between" align="center" no-gutters class="mx-10 mx-sm-0">
                                    <span>Push to tawq:
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <v-icon small v-on="on">mdi-information-outline</v-icon>
                                            </template>
                                            <span>When ON, push button to toggle audio recording<br/> When OFF, pick up the phone to record audio.</span>
                                        </v-tooltip>
                                    </span>
                                    <v-switch v-model="formData.pushToTawq" inset color="primary" :label="formData.pushToTawq ? 'ON' : 'OFF'"></v-switch>
                                </v-row>
                                <v-divider class="pb-2"/>

                                <v-divider class="mx-10"/>
                                <v-row justify="space-between" align="center" no-gutters class="mx-10 mx-sm-0">
                                    <v-col cols="12" justify="center" align="center" class="ma-0 pa-0">
                                        <span class="text-h6 font-weight-light">Viewing Settings</span>
                                    </v-col>
                                </v-row>

                                <v-divider/>
                                <v-row justify="space-between" align="center" no-gutters class="mx-10 mx-sm-0">
                                    <span><v-icon class="mr-1" style="vertical-align: text-bottom">{{ formData.playbackStyle ? 'mdi-cog-sync' : 'mdi-cog-play' }}</v-icon>Playback Style:
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <v-icon small v-on="on">mdi-information-outline</v-icon>
                                            </template>

                                            <span>'pauseplay' - Audio segment plays while video is paused.<br/> 'continuous' - Audio and video segments play at same time.</span>
                                        </v-tooltip>
                                        <br/><span class="font-weight-light">{{formData.playbackStyle ? `'continuous'` : `'pauseplay'`}}</span>
                                    </span>
                                    <v-switch v-model="formData.playbackStyle" inset color="primary"></v-switch>
                                </v-row>
                                <v-divider class="mx-10"/>
                                <v-row v-if="!formData.playbackStyle" justify="space-between" align="center" no-gutters class="px-10 mx-sm-0">
                                    <span><v-icon class="mr-1" style="vertical-align: text-bottom">{{ formData.playbackStyleAudioFirst ? 'mdi-ray-start-arrow' : 'mdi-ray-end-arrow' }}</v-icon>Audio First:
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <v-icon small v-on="on">mdi-information-outline</v-icon>
                                            </template>
                                            <span>When ON, audio segment plays BEFORE the video segment.<br/> When OFF, audio segment plays AFTER the video segment.</span>
                                        </v-tooltip>
                                    </span>
                                    <v-switch v-model="formData.playbackStyleAudioFirst" inset color="primary" :disabled="formData.playbackStyle" :label="formData.playbackStyleAudioFirst ? 'ON' : 'OFF'"></v-switch>
                                </v-row>
                                <v-row v-if="formData.playbackStyle" justify="space-between" align="center" no-gutters class="px-10 mx-sm-0">
                                    <span><icon-overlap-skip v-if="formData.playbackStyleSameStart" class="mr-1"/><icon-overlap-chop v-else class="mr-1"/>Skip Overlap:
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <v-icon small v-on="on">mdi-information-outline</v-icon>
                                            </template>
                                            <span>When ON, skips any overlapping audio segments.<br/> When OFF, ends current audio segment early to play next audio.</span>
                                        </v-tooltip>
                                    </span>
                                    <v-switch v-model="formData.playbackStyleSameStart" inset color="primary" :disabled="!formData.playbackStyle" :label="formData.playbackStyleSameStart ? 'ON' : 'OFF'"></v-switch>
                                </v-row>
                                <v-divider/>

                                <v-row justify="space-between" align="center" no-gutters class="mx-10 mx-sm-0">
                                    <span><v-icon class="mr-1" style="vertical-align: text-bottom">{{ formData.captionAudio ? 'mdi-volume-high' : 'mdi-volume-off' }}</v-icon>Caption Audio:
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <v-icon small v-on="on">mdi-information-outline</v-icon>
                                            </template>
                                            <span>When ON, caption audio will be UNMUTED.<br/> When OFF, caption audio will be MUTED.</span>
                                        </v-tooltip>
                                    </span>
                                    <v-switch v-model="formData.captionAudio" inset color="primary" :label="formData.captionAudio ? 'ON' : 'OFF'"></v-switch>
                                </v-row>
                                <v-divider/>

                                <v-row justify="space-between" align="center" no-gutters class="mx-10 mx-sm-0">
                                    <span><v-icon class="mr-1" style="vertical-align: text-bottom">{{ formData.showCaptions ? 'mdi-closed-caption' : 'mdi-closed-caption-outline' }}</v-icon>Show Captions:
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <v-icon small v-on="on">mdi-information-outline</v-icon>
                                            </template>
                                            <span>When ON, caption will be shown while audio plays.<br/> When OFF, caption will NOT be shown while audio plays.</span>
                                        </v-tooltip>
                                    </span>
                                    <v-switch v-model="formData.showCaptions" inset color="primary" :label="formData.showCaptions ? 'ON' : 'OFF'"></v-switch>
                                </v-row>
                                <v-divider/>

                                <v-row justify="space-between" align="center" no-gutters class="mx-10 mx-sm-0">
                                    <span>Auto Advance:
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <v-icon small v-on="on">mdi-information-outline</v-icon>
                                            </template>
                                            <span>FOR TEXT POSTS ONLY:<br/> When ON, Text Cards will, by default, automatically advance to the next card.<br/> When OFF, advancing to the next Text Card requires user input.</span>
                                        </v-tooltip>
                                    </span>
                                    <v-switch v-model="formData.autoSkipDelay" inset color="primary" :label="formData.autoSkipDelay ? 'ON' : 'OFF'"></v-switch>
                                </v-row>
                                <v-divider class="mx-10"/>
                                <v-row justify="space-between" align="center" no-gutters class="mx-10 mx-sm-0 mt-2">
                                    <v-col cols="12" class="">
                                        <div class="d-flex justify-center">
                                            <span>Auto Advance Delay:
                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on }">
                                                        <v-icon small v-on="on">mdi-information-outline</v-icon>
                                                    </template>
                                                    <span>The amount of time to wait before automatically advancing to the next Text Card.</span>
                                                </v-tooltip>
                                            </span>
                                        </div>
                                        <div class="d-flex justify-center mb-1">
                                            <span>{{ formData.autoSkipDelayTime }} seconds</span>
                                        </div>
                                        <v-slider v-model="formData.autoSkipDelayTime" min="0.25" max="20.0" step="0.25" hide-details prepend-icon="mdi-minus" append-icon="mdi-plus" @click:prepend="autoSkipDelayTimeChange('autoSkipDelayMinus')" @click:append="autoSkipDelayTimeChange('autoSkipDelayPlus')"  @input="autoSkipDelayTimeChange"></v-slider>
                                        <div class="d-flex justify-space-between my-2">
                                            <v-btn small rounded class="mr-1" @click.stop="formData.autoSkipDelayTime = 1.00">1.0</v-btn>
                                            <v-btn small rounded class="mr-1" @click.stop="formData.autoSkipDelayTime = 2.50">2.5</v-btn>
                                            <v-btn small rounded class="mr-1" @click.stop="formData.autoSkipDelayTime = 5.00">5.0</v-btn>
                                            <v-btn small rounded class="mr-1" @click.stop="formData.autoSkipDelayTime = 7.50">7.5</v-btn>
                                            <v-btn small rounded @click.stop="formData.autoSkipDelayTime = 10.00">10.0</v-btn>
                                        </div>
                                    </v-col>
                                    <!-- </v-card> -->
                                </v-row>
                                <v-divider class="hidden-xs-only"/>
                            </v-col>
                        </v-row>
                        <!-- END ADVANCED SETTINGS -->
                        <v-divider class="pb-2"/>

                        <v-row justify="center" align="center" no-gutters>
                            <v-btn rounded large depressed color="primary" :loading="isSaving" :disabled="!isDirty || isSaving || !formValid" @click="saveChangedSettings">Save</v-btn>
                        </v-row>
                    </v-col>
                </v-row>
            </v-form>

        </v-col>
    </v-row>
</template>

<script>
import firebase from "../../firebaseConfig.js";
import { IconOverlapSkip, IconOverlapChop } from "./icons/overlapIcons";
import { SETTINGS_FORM_DEFAULTS } from "../../settingsDefaults.js";
// import fb from 'firebase/app';

// Allow letters (all languages), combining marks, digits, spaces,
// underscore, apostrophe (ASCII and curly), hyphen/en dash/em dash, and dot.
const FULLNAME_RE = /^[\p{L}\p{M}\p{Nd}\p{Zs}_'.\-\u2019\u2013\u2014]+$/u;

// Optional: normalize + trim, then length-check separately
const normalize = s => (s ?? '').normalize('NFC').trim();

// Optional: collapse multiple spaces to one
const clean = s => normalize(s).replace(/\p{Zs}+/gu, ' ');


export default {
    components: {
        IconOverlapSkip,
        IconOverlapChop,
    },
    metaInfo: {
        title: "Settings - tawqin"
    },
    data: function() {
        return {
            loading: false,
            isSaving: false,
            formValid: false,

            userData: {},
            formData: {
                imageInput: null,
                profilePicture: null,
                username: "",
                darkTheme: false,
                languageSelected: {
                    text: "English (United States)",
                    value: "en-US",
                    // model: 0,
                    // location: 0,
                    // recognizerEnum: 0,
                    // recognizer: "gl-en-us-en-in-en-gb",
                },
                pushToTawq: false, 
                playbackStyle: SETTINGS_FORM_DEFAULTS.playbackStyle, // canon: continuous (true)
                playbackStyleAudioFirst: false, // pauseplay-only sub-setting; not part of canon
                playbackStyleSameStart: SETTINGS_FORM_DEFAULTS.playbackStyleSameStart, // canon: skip overlap (true)
                captionAudio: SETTINGS_FORM_DEFAULTS.captionAudio, // canon: narration audio on (true)
                showCaptions: SETTINGS_FORM_DEFAULTS.showCaptions,
                autoSkipDelay: false,
                autoSkipDelayTime: 2.5,
            },
            originalData: null,

            advancedShow: false,
            userDataHasBeenUpdated: false,
            userDataChanged: false,
            formIsValid: false,

            userProfilePic: firebase.auth.currentUser.photoURL,
            image: "",
            // imageInput: null,
            previewImage: "",
            // newImageUrl: "",
            profileImageFileLimit: 6000000,
            profileImageRules: [(value) => !value || value.size < this.profileImageFileLimit || "Image must be less than 6 MB",],
            profileImageError: false,

            username: firebase.auth.currentUser.displayName,
            newUsername: "",
            showEditUsername: false,
            // usernameRules: [
            // (value) => ((value ?? "") !== "") || "Name is Required.",
            // (value) => ((value ?? "").length <= 50) || "Name must be 50 characters for less.",
            // ],

            usernameRules: [
                (value) => ((clean(value) ?? "") !== "") || "Full Name is Required.",
                (value) => ((clean(value) ?? "").length <= 50) || "Full Name must be 50 characters or less",
                (value) => FULLNAME_RE.test(clean(value)) || "Full Name is not valid, please try again",
            ],


            email: firebase.auth.currentUser.email,

            // theme: null, //this.savedUserData?.darkTheme, //this.$store.state.userData?.darkTheme,

            languageName: "English (United States)",
            languageCode: "en-US",//null,//In the future this can be changed to the users personal preference from userData (which could be changed in settings).
            languageSelected: {
                text: "English (United States)",
                value: "en-US",
                // model: 0,
                // location: 0,
                // recognizerEnum: 0,
                // recognizer: "gl-en-us-en-in-en-gb",
            },
        }
    },
    methods: {
        openProfileImageFile: function() {
            if (this.profileImageError) return this.profileImageError = false;
            if (!this.formData.imageInput) { // there is no image selected from input, open fileInput
                this.$refs.fileInput.$refs.input.click(); // open fileInput for image select
            } else { // there is an image selected, remove it and set to default
                this.$window.URL.revokeObjectURL(this.previewImage);
                this.formData.imageInput = null;
                this.previewImage = '';
            }
        },
        getProfileImageFile: function() { // called each time a user selects an image
            if (this.formData.imageInput.size > this.profileImageFileLimit) { // image exceeds this.profileImageFileLimit
                this.profileImageError = true;
                this.formData.imageInput = null;
            } else { // image selected meets the criteria, show it as previewImage
                this.previewImage = this.$window.URL.createObjectURL(this.formData.imageInput);
            }
        },
        validateUsername: function() {
            const current = (this.formData.username ?? '').trim();
            const original = (this.originalData.username ?? '').trim();

            if (current === '' || current === original || current.length > 50) {
                this.formData.username = this.originalData.username ?? '';
            }
            this.showEditUsername = false;
            // console.log("validateUsername: ", this.formData.username.trim());
            // if (this.formData.username === "" || this.formData.username === this.originalData.username || this.formData.username.length > 50) this.formData.username = this.originalData.username;
            // this.showEditUsername = false;
        },
        languageChanged: function (text, value) {
            this.formData.languageSelected = {text: text, value: value};
            this.languageName = this.formData.languageSelected.text;
            this.languageCode = this.formData.languageSelected.value;
        },
        autoSkipDelayTimeChange: function (event) {
            if (event === "autoSkipDelayPlus") this.formData.autoSkipDelayTime += 0.25;
            else this.formData.autoSkipDelayTime -= 0.25;
        },
        deepEqual: function (a, b) {
            // console.log("a: ", a, "\nb: ", b);
            if (a === b) return true;
            if (typeof a !== 'object' || typeof b !== 'object' || !a || !b) return false;
            const ka = Object.keys(a), kb = Object.keys(b);
            if (ka.length !== kb.length) return false;
            for (const k of ka) {
                if (!kb.includes(k)) return false;
                if (!this.deepEqual(a[k], b[k])) return false;
            }
            return true;
        },
        getChangedFields() {
            const changed = {}
            const keys = Object.keys(this.formData).filter(k => k !== 'imageInput');
            for (const k of keys) {
                if (!this.deepEqual(this.formData[k], this.originalData[k])) {
                    changed[k] = this.formData[k];
                }
            }
            if (this.formData.imageInput) changed.imageInput = this.formData.imageInput; // Handle photo separately (File upload)

            return changed;
        },
        // resetFormData: function() {
        //     const u = this.$store.state.userData;
        //     this.formData = {
        //         imageInput: null,
        //         profilePicture: u.profilePicture || null,
        //         username: u.username || "",
        //         darkTheme: u.darkTheme || false,
        //         languageSelected: u.languageSelected || {
        //             text: "English (United States)",
        //             value: "en-US",
        //         },
        //         pushToTawq: !!u.pushToTawq,
        //         playbackStyle: !!u.playbackStyle,
        //         playbackStyleAudioFirst: !!u.playbackStyleAudioFirst,
        //         playbackStyleSameStart: !!u.playbackStyleSameStart,
        //         captionAudio: !!u.captionAudio,
        //         showCaptions: !!u.showCaptions,
        //         autoSkipDelay: u.autoSkipDelay || false,
        //         autoSkipDelayTime: u.autoSkipDelayTime || 2.5,
        //     }
        //     this.originalData = JSON.parse(JSON.stringify(this.formData));
        // },
        saveChangedSettings: async function() {

            this.isSaving = true;

            const validateForm = await this.$refs.form.validate();
            if (!validateForm) return this.isSaving = false;

            try {
                const changed = this.getChangedFields();
                if (Object.keys(changed).length === 0) return; // double check to make sure there are changes, will return here if no changes


                // 1) handle photo upload first (if any)
                if (changed.imageInput) {
                    const url = await this.uploadNewProfilePicture(firebase.auth.currentUser.uid, changed.imageInput);
                    // console.log("url: ", url);
                    if (url) changed.profilePicture = url;
                    delete changed.imageInput;
                }

                // 2) write user's own doc with everything that changed
                await firebase.db.collection('userData').doc(firebase.auth.currentUser.uid).update(changed);

                // 3) propagate if username and/or photo changed
                const needsPropagation = 'username' in changed || 'profilePicture' in changed;
                if (needsPropagation) {
                    const fanout = {};
                    if ('username' in changed) {
                        await firebase.auth.currentUser.updateProfile({ displayName: changed.username });
                        fanout.username = changed.username;
                    }
                    if ('profilePicture' in changed) fanout.photoURL = changed.profilePicture;
                    await this.propagateUserDataEverywhere(firebase.auth.currentUser.uid, fanout);
                }

                this.$store.dispatch('bindUserData', firebase.auth.currentUser);
                setTimeout(() => {
                    const u = this.$store.state.userData;
                    if (u.darkTheme !== this.$vuetify.theme.dark) this.$vuetify.theme.dark = u.darkTheme;
                    this.formData = {
                        imageInput: null,
                        profilePicture: u.profilePicture || null,
                        username: u.username || "",
                        darkTheme: u.darkTheme || false,
                        languageSelected: u.languageSelected || {
                            text: "English (United States)",
                            value: "en-US",
                        },
                        pushToTawq: !!u.pushToTawq,
                        playbackStyle: u.playbackStyle ?? SETTINGS_FORM_DEFAULTS.playbackStyle, // canon fall-throughs (see settingsDefaults.js)
                        playbackStyleAudioFirst: !!u.playbackStyleAudioFirst,
                        playbackStyleSameStart: u.playbackStyleSameStart ?? SETTINGS_FORM_DEFAULTS.playbackStyleSameStart,
                        captionAudio: u.captionAudio ?? SETTINGS_FORM_DEFAULTS.captionAudio,
                        showCaptions: u.showCaptions ?? SETTINGS_FORM_DEFAULTS.showCaptions,
                        autoSkipDelay: u.autoSkipDelay || false,
                        autoSkipDelayTime: u.autoSkipDelayTime || 2.5,
                    }
                    this.originalData = JSON.parse(JSON.stringify(this.formData));
                }, 500);

                if ('profilePicture' in changed) {
                    this.$window.URL.revokeObjectURL(this.previewImage);
                    this.formData.imageInput = null;
                    this.previewImage = '';
                    this.userProfilePic = firebase.auth.currentUser.photoURL || this.formData.profilePicture;
                }
                // this.resetFormData();
                this.$store.commit('alertUser', { show: true, text: `Settings Updated!`, type: 'snackbar' });
            } catch (error) {
                this.$store.commit('alertUser', { show: true, text: `Something went wrong. Please try again.`, type: 'snackbar' });
                console.error('ERROR UPDATING SETTINGS', error);
                this.isSaving = false;
            } finally {
                setTimeout(() => {
                    this.isSaving = false;
                }, 1000);
            }
        },
        uploadNewProfilePicture: async function (uid, file) {
            if (!file) return null;

            try {
                const metadata = {
                    cacheControl: 'public,max-age=604800', // 1 week
                };

                const storageRef = firebase.storage.ref("userProfilePics");
                const photoRef = storageRef.child(`/${uid}/1`);

                const snapshot = await photoRef.put(file, metadata);

                const downloadURL = await snapshot.ref.getDownloadURL();

                await firebase.auth.currentUser.updateProfile({ photoURL: downloadURL });

                return downloadURL;
            } catch (error) {
                console.error('ERROR UPLOADING/UPDATING PHOTO', error);
                this.$store.commit('alertUser', { show: true, text: `Something went wrong. ${err.message}`, type: 'snackbar' });
            }
        },
        propagateUserDataEverywhere: async function (uid, fanout) {
            const username = fanout.username || this.formData.username;
            const profilePicture = fanout.photoURL || this.formData.profilePicture;

            const payload = {
                userId: uid,
                username: username, //fanout.username || this.formData.username,
                profilePicture: profilePicture, //fanout.photoURL || this.formData.profilePicture,
            };

            const paths = [
                'publicposts/userdata',
                'groupposts/userdata',
                'audiosegments/userdata',
                'groups/userdata',
                'friends/userdata',
                'notifications/friends/userdata',
            ];

            // Fire in parallel with retries per endpoint
            const tasks = paths.map(path =>
                this.withRetry(() => this.$http.put(path, payload), { tries: 3, base: 300 }).then(res => ({ path, ok: true, status: res.status })).catch(err => ({ path, ok: false, error: err }))
            );

            const results = await Promise.all(tasks);

            const failed = results.filter(r => !r.ok);
            if (failed.length) {
                // Surface a single snackbar & log details
                this.$store.commit('alertUser', {show: true, text: `Some updates failed: ${failed.map(f => f.path).join(', ')}`, type: 'snackbar'});
                // Optional: console detailed errors
                failed.forEach(f => console.error(`Propagation failed for ${f.path}`, f.error));
                return { ok: false, failed, results };
            }

            return { ok: true, results };

            // const tasks = [
            //     updateCollection('publicposts/userdata', uid, username, profilePicture),
            //     updateCollection('groupposts/userdata', uid, username, profilePicture),
            //     updateCollection('audiosegments/userdata', uid, username, profilePicture),
            //     updateCollection('groups/userdata', uid, username, profilePicture),
            //     updateCollection('friends/userdata', uid, username, profilePicture),
            //     updateCollection('notifications/friends/userdata', uid, username, profilePicture),
            // ];
            // await Promise.all(tasks);
        },
        withRetry: async function (fn, { tries = 3, base = 300 } = {}) {
            let lastErr;
            for (let i = 0; i < tries; i++) {
                try {
                    return await fn();
                } catch (err) {
                    lastErr = err;
                    if (i === tries - 1) break;
                    const delay = base * Math.pow(2, i); // 300ms, 600ms, 1200ms...
                    await new Promise(r => setTimeout(r, delay));
                }
            }
            throw lastErr;
        },
        // updateCollection: async function (collection, uid, username, profilePicture) {
        // },


        // UpdateInformation: function() {
        //     if (this.formIsValid || this.newImageUrl.size > this.profileImageFileLimit) {
        //         return;
        //     } else {
        //         // this.$store.dispatch('unbindUserData');
        //         this.userDataHasBeenUpdated = true;
        //         if (!this.newImageUrl && !this.newUsername){
        //             this.updateUserMetaData();
        //             return;
        //         } else if (this.newImageUrl){
        //             this.UpdatePhotoURL();
        //         } else {
        //             this.updateUserData();
        //         }
        //     }
        // },
        updateUserData: function() {
            let name;
            if (this.newUsername === ""){
                name = this.username;
            } else {
                name = this.newUsername;
            }
            firebase.auth.currentUser.updateProfile({displayName: name,}).then(() => {
                this.username = firebase.auth.currentUser.displayName;
                this.updatePublicPostsMetadata();
                this.updateGroupPostsMetadata();
                this.updateAudioSegmentMetadata();
                this.updateGroupMetadata();
                this.updateFriendMetadata();
                this.updateNotificationMetadata();
                this.updateUserMetaData();
                this.newUsername = "";
            });
        },
        updateUserMetaData: function() {
            setTimeout(() => {
                this.userDataHasBeenUpdated = false;
                this.userDataChanged = false;
                this.$store.commit('alertUser', { show: true, text: `Settings Updated!`, type: 'snackbar' });
                this.$store.dispatch('bindUserData', firebase.auth.currentUser);
            }, 500);
            // console.log("this.userProfilePic", this.userProfilePic)
            let userDataDoc = firebase.db.collection("userData").doc(`${firebase.auth.currentUser.uid}`);
            userDataDoc.set({
                username: this.username,
                profilePicture: this.userProfilePic,
                // profanityFilter: this.userData.profanityFilter,
                darkTheme: this.userData.darkTheme,
                pushToTawq: this.userData.pushToTawq,
                playbackStyle: this.userData.playbackStyle, // true is continuous, false is pauseplay.
                playbackStyleAudioFirst: this.userData.playbackStyleAudioFirst, // if true, when segment start is reached, video will pause and audio will play; else, when segment end is reached video will pause and audio will play.
                playbackStyleSameStart: this.userData.playbackStyleSameStart, // if true, audio segment will play and skip overlapping segments; else, if overlap, audio will stop (cut off) and play next segment.
                captionAudio: this.userData.captionAudio,
                showCaptions: this.userData.showCaptions,
                dualDevice: this.userData.dualDevice,
                languageSelected: (typeof this.userData.languageSelected === 'undefined') ? {text: this.languageName, value: this.languageCode } : this.userData.languageSelected,
            }, {merge: true});
        },
        updateFriendMetadata: function() {
            /* this method will update the users' data in the friends collection of all the userData of the users friends */
            this.$http.put(`friends/userdata`, {
                "username": this.username,
                "userProfilePhoto": this.userProfilePic,
                "userId": firebase.auth.currentUser.uid,
            }).then((response) => {
                if (response.status == 200) {
                    // console.log("completed the friend metadata update!");
                }
            }).catch((error) => {
                this.$store.commit('alertUser', { show: true, text: `Something went wrong. ${error.message}`, type: 'snackbar' });
            });
        },
        updateNotificationMetadata: function() {
            /* this method will update the users' data in the notifications collection for the friend requests that haven't been accepted yet */
            this.$http.put(`notifications/friends/userdata`, {
                "username": this.username,
                "userProfilePhoto": this.userProfilePic,
                "userId": firebase.auth.currentUser.uid,
            }).then((response) => {
                if (response.status == 200) {
                    // console.log("completed the not accepted friend notifications metadata update!");
                }
            }).catch((error) => {
                this.$store.commit('alertUser', { show: true, text: `Something went wrong. ${error.message}`, type: 'snackbar' });
            });
        },
        updateGroupMetadata: function() {
            /* this method will update the users' data in the members collection of all the groups they a part of */
            this.$http.put(`groups/userdata`, {
                "username": this.username,
                "userProfilePhoto": this.userProfilePic,
                "userId": firebase.auth.currentUser.uid,
            }).then((response) => {
                if (response.status == 200) {
                    // console.log("completed the group metadata update!");
                }
            }).catch((error) => {
                this.$store.commit('alertUser', { show: true, text: `Something went wrong. ${error.message}`, type: 'snackbar' });
            });
        },
        updateGroupPostsMetadata: function() {
            this.$http.put(`groupposts/userdata`, {
                "username": this.username,
                "userProfilePhoto": this.userProfilePic,
                "userId": firebase.auth.currentUser.uid,
            }).then((response) => {
                if (response.status == 200) {
                    // console.log("completed the groupcposts update!");
                }
            }).catch((error) => {
                this.$store.commit('alertUser', { show: true, text: `Something went wrong. ${error.message}`, type: 'snackbar' });
            });
        },
        updatePublicPostsMetadata: function() {
            this.$http.put(`publicposts/userdata`, {
                "username": this.username,
                "userProfilePhoto": this.userProfilePic,
                "userId": firebase.auth.currentUser.uid,
            }).then((response) => {
                if (response.status == 200) {
                    // console.log("completed the publicposts update!");
                }
            }).catch((error) => {
                this.$store.commit('alertUser', { show: true, text: `Something went wrong. ${error.message}`, type: 'snackbar' });
            });
        },
        updateAudioSegmentMetadata: function() {
            this.$http.put(`audiosegments/userdata`, {
                "username": this.username,
                "userProfilePhoto": this.userProfilePic,
                "userId": firebase.auth.currentUser.uid,
            }).then((response) => {
                if (response.status == 200) {
                    // console.log("completed the audiosegs update!");
                } else {
                    // console.log("couldn't complete publicposts the update");
                }
            }).catch((error) => {
                this.$store.commit('alertUser', { show: true, text: `Something went wrong. ${error.message}`, type: 'snackbar' });
            });
        },

        // UpdatePhotoURL: function() {
        //     const metadata = {
        //         cacheControl: 'public,max-age=604800' // 1 week
        //     }
        //     var file = this.newImageUrl;
        //     if (file) {
        //         this.loading = true;
        //         this.isSaving = true;
        //     }
        //     var storageRef = firebase.storage.ref("userProfilePics");
        //     var photoRef = storageRef.child("/" + firebase.auth.currentUser.uid + "/1");
        //     var uploadTask = photoRef.put(file, metadata);
        //     uploadTask.on("state_changed",() => {},(error) => {
        //         console.log("ERROR UPLOADING THE FILE")
        //         this.$store.commit('alertUser', { show: true, text: `Something went wrong. ${error.message}`, type: 'snackbar' });
        //     },() => {
        //         uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
        //             this.loading = false;
        //             this.isSaving = false;
        //             this.formData.imageInput = null;
        //             firebase.auth.currentUser.updateProfile({
        //                 photoURL: downloadURL,
        //             }).then(() => {
        //                 this.userProfilePic = firebase.auth.currentUser.photoURL;
        //                 this.updateUserData();
        //                 this.newImageUrl = "";
        //             }).catch((err) => {
        //                 console.log("ERROR UPDATING THE FIREBASE.CURRENTUSER");
        //                 this.$store.commit('alertUser', { show: true, text: `Something went wrong. ${err.message}`, type: 'snackbar' });
        //             });
        //         }).catch((err) => {
        //             console.log("ERROR RETRIEVING THE DOWNLOAD URL OF THE IMAGE")
        //             this.$store.commit('alertUser', { show: true, text: `Something went wrong. ${err.message}`, type: 'snackbar' });
        //         });
        //     });
        // },








        updateAllPosts: function () {
            firebase.db.collection("publicPosts").get().then((snapshot) => {
                snapshot.forEach(async (doc) => {
                    if (!doc.data().mediaType) {
                        await firebase.db.collection("publicPosts").doc(doc.data().postId).set({/*mediaType: "video"*/},{merge: true});
                    }
                });
            });
            firebase.db.collection("groupPosts").get().then((snapshot) => {
                snapshot.forEach(async (doc) => {
                    if (!doc.data().mediaType) {
                        await firebase.db.collection("groupPosts").doc(doc.data().postId).set({/*mediaType: "video"*/},{merge: true});
                    }
                });
            });
        },

        UpdateAllUsers: function () {
            firebase.db.collection("userData").get().then((snapshot) => {
                snapshot.forEach( async (doc)=>{
                    if(!doc.data().dualDevice){
                        // console.log(doc.data().userId);
                        await firebase.db.collection("userData").doc(doc.data().userId).set({/*dualDevice: false*/},{merge: true})
                    }
                });
            });
        },

        /* FOR TESTING ONLY */
        unlinkGoogleAccount: function () {
            const user = firebase.auth.currentUser;

            user.providerData.forEach(provider => {
                if (provider.providerId === "google.com") {
                    user.unlink("google.com").then(() => {
                        console.log("Google Account Unlinked");
                    }).catch((error) => {
                        console.log("Error: ", error.message);
                    });
                }
            });
        },
        sortEmails: function () {
            const emailCategories = {
                'yahoo.com': [],
                'gmail.com': [],
                'microsoft.com': [],
                'edu': [],
                'org': [],
                'net': [],
                'biz': [],
                'in': [],
                'other': []
            };

            firebase.db.collection("userData").get().then((querySnapshot) => {
                    querySnapshot.forEach((doc) => {
                        const email = doc.data().email;
                        if (email) {
                            const emailParts = email.split("@");
                            const domain = emailParts[1];
                            const category = domain.endsWith(".edu") ? 'edu' :
                                domain.endsWith(".org") ? 'org' :
                                domain.endsWith(".net") ? 'net' :
                                domain.endsWith(".biz") ? 'biz' :
                                domain.endsWith(".in") ? 'in' :
                                domain === "hotmail.com" || domain === "outlook.com" || domain === "msn.com" ? 'microsoft.com' :
                                emailCategories.hasOwnProperty(domain) ? domain : 'other';
                            emailCategories[category].push(email);
                        }
                    });

                    for (const category in emailCategories) {
                        console.log(`${category}: ${emailCategories[category].length}`); // Log the count of emails in each category
                    }
                    // console.log("otherEmails: ", emailCategories['other']); // Log the emails in other category
                }).catch((error) => {
                    console.log("Error getting documents: ", error);
                });
        },
        getAudio: async function () {
            // this function is used to get the audio and captions (subtitles) data for a specific audioSegment.
            // it then calls this.sortAudio(audio,captions), which will take the data from above and sort it by audioStart time.
            // finally it sets the newly sorted data to a specific audioSegment in the database.
            // was only used to update the pinnedPost titled 'how to use tawq.in' - postId: rXm4nZfBwDP9DIeycLzS - when the audioStart times were updated.
            // NOTE: this, or something similiar, will need to be used if we ever give the option for a user to update start times of individual audioSegments.
            const docId = "G7jFjyw1UWL1dSL0wgRN";
            const audioDocId = "mMeqakabW2SF9VWYrvTt";
            let audioData = [];
            let captionData = [];
            // let data = {};
            firebase.db.collection("audioSegments").doc(docId).get().then(async (doc) => {
                audioData =  doc.data().audio;
                captionData =  doc.data().subtitles;
                // data = doc.data();
                let newData = await this.sortAudio(audioData, captionData);
                // console.log("newData: ", newData);

                // CHANGES MADE ON FEBRUARY 14, 2024
                // "how to use tawq.in" old postAudioDataId: G7jFjyw1UWL1dSL0wgRN
                // the above in the database under collection audioSegments now has 'old-' in front of the postId so it doesn't show in the list of audioElements
                // "how to use tawq.in" new postAudioDataId: mMeqakabW2SF9VWYrvTt
                // END CHANGES MADE ON FEBRUARY 14, 2024

                firebase.db.collection("audioSegments").doc(audioDocId).set({
                    audio: newData.audio,
                    subtitles: newData.captions,
                }, {merge: true});
            }).catch((error) => {
                console.log("error: ", error);
            });
        },
        sortAudio: async function (audio, captions) {
            // console.log("audio: ", audio);
            // console.log("caption: ", caption);
            return new Promise((resolve) => {
                if (audio.length <= 1){
                    resolve( { audio: audio, captions: captions } );
                } else {
                    var swap;
                    let n = audio.length-1;
                    var newAudio = audio;
                    var newCaptions = captions;
                    do {
                        swap = false;
                        for ( var i = 0; i < n; i++ ){
                            if(typeof audio[i] === 'undefined' || typeof captions[i] === 'undefined'){
                                continue;
                            }
                            if (newAudio[i].audioStart > newAudio[i+1].audioStart){
                                var temp = newAudio[i];
                                var tempCaption = newCaptions[i];
                                newAudio[i] = newAudio[i+1];
                                newAudio[i+1] = temp;
                                newCaptions[i] = newCaptions[i+1];
                                newCaptions[i+1] = tempCaption;
                                swap = true;
                            }
                        }// for loop
                    } while(swap);
                    // console.log("THE NEW ARRAY IN BUBBLE SORT, ", newAudio);
                    // console.log("bubbleSort() audio: ", newAudio);
                    // console.log("bubbleSort() captions: ", newCaptions);
                    resolve( { audio: newAudio, captions: newCaptions } );
                }
            })
        },
        moveDocument: async function () {
            const docId = "BmMrG4QpPpOuONnankqJ";
            const doc = await firebase.db.collection("publicPosts").doc(docId).get();
            // console.log("document: ", doc.data());
            await firebase.db.collection("failedPublicPosts").doc(docId).set(doc.data(), {merge: true});

        },
        getAllPosts: async function () { // get all public posts
            const pubilcPostsCollection = firebase.db.collection("publicPosts");
            const snapshot = await pubilcPostsCollection.get();
            console.log("snapshot size: ", snapshot.size); // see how many public posts we have
            // let count = 0;
            // pubilcPostsCollection.get().then((snapshot) => {
            //     snapshot.forEach((doc) => {
            //         count += 1;
            //     });
            //     console.log("COUNT: ", count);
            // });
        },
        createUserDataInFirebaseFirestore: async function () {
            const user = {
                uid: "emKGest0c3ZqeS75A0aJVbuCbqw1",
                displayName: "Tawqin Test",
                email: "tawqintest@gmail.com",
                emailVerified: false,
                signUpMethod: "email",
                profilePicture: "",
            }
            const userData = {
                    userId: user.uid,
                    fullname: user.displayName,
                    email: user.email,
                    username: user.displayName,
                    profanityFilter: false,
                    darkTheme: true,
                    emailVerified: user.emailVerified,
                    pushToTawq: true,
                    postsCreated: 0,
                    playbackStyle: SETTINGS_FORM_DEFAULTS.playbackStyle, // canon: continuous (true)
                    captionAudio: SETTINGS_FORM_DEFAULTS.captionAudio, // canon: narration audio on (true)
                    dualDevice: false,
                    signUpMethod: user.signUpMethod,
                    signUpDate: new Date(),
                    profilePicture: user.profilePicture,
                }
            await firebase.db.collection("userData").doc(userData.userId).set(userData);
        },
        extractLanguageCodesBasedOnModelAndLocation: function () {
            let languageCodesLists = {
                // longGlobal: [],
                // telephonyGlobal: [],
                chirpUSCentral: [],
                chirp2USCentral: [],
                // defaultDoesNotMatchOtherCases: [],
            };

            this.$languageCodes.forEach((lang) => {
                // switch (true) {
                //     case lang.model === 0 && lang.location === 0:
                //         languageCodesLists.longGlobal.push(lang.value);
                //         break;
                //     case lang.model === 3 && lang.location === 0:
                //         languageCodesLists.telephonyGlobal.push(lang.value);
                //         break;
                //     case lang.model === 1 && lang.location === 1:
                //         languageCodesLists.chirpUSCentral.push(lang.value);
                //         break;
                //     case lang.model === 2 && lang.location === 1:
                //         languageCodesLists.chirp2USCentral.push(lang.value);
                //         break;
                //     default:
                //         languageCodesLists.defaultDoesNotMatchOtherCases.push(lang.value);
                //         break;
                // }
                if (lang.model === 1 && lang.location === 1) {
                    languageCodesLists.chirpUSCentral.push(lang.value);
                } else if (lang.model === 2 && lang.location === 1) {
                    languageCodesLists.chirp2USCentral.push(lang.value);
                }
            });

            // console.log("languageCodesLists: ", languageCodesLists);

            // // Convert the languageCodesLists to a formatted string
            // let formattedString = '';
            // for (const [key, values] of Object.entries(languageCodesLists)) {
            //     formattedString += `${key}:\n`;
            //     values.forEach(value => {
            //         formattedString += `"${value}",\n`;
            //     });
            //     formattedString += '\n\n'; // Add triple new lines between lists
            // }

            // // Convert the languageCodesLists to a formatted string for recognizer: "" - in language-codes.js for $languageCodes
            // let formattedString = '';
            // for (const [key, values] of Object.entries(languageCodesLists)) {
            //     let prefix;
            //     switch (key) {
            //         case 'longGlobal':
            //             prefix = 'gl-';
            //             break;
            //         case 'telephonyGlobal':
            //             prefix = 'gt-';
            //             break;
            //         case 'chirpUSCentral':
            //             prefix = 'ucc-';
            //             break;
            //         case 'chirp2USCentral':
            //             prefix = 'ucc2-';
            //             break;
            //         default:
            //             prefix = 'default-';
            //             break;
            //     }

            //     formattedString += `${key}:\n`;
            //     for (let i = 0; i < values.length; i += 3) {
            //         const group = values.slice(i, i + 3).map(val => val.toLowerCase()).join('-');
            //         formattedString += `"${prefix}${group}",\n`;
            //     }
            //     formattedString += '\n\n'; // Add triple new lines between lists
            // }

            // Convert the languageCodesLists to a formatted string for chirp and chirp_2
            let formattedString = '';
            for (const [key, values] of Object.entries(languageCodesLists)) {
                let prefix;
                switch (key) {
                    case 'chirpUSCentral':
                        prefix = 'ucc-';
                        break;
                    case 'chirp2USCentral':
                        prefix = 'ucc2-';
                        break;
                }

                formattedString += `${key}:\n`;
                values.forEach(val => {
                    formattedString += `"${prefix}${val.toLowerCase().replace(/-/g, '-')}",\n`;
                });
                formattedString += '\n\n'; // Add triple new lines between lists
            }

            // console.log(formattedString);

            // Write the formatted string to a text file
            this.downloadToFile(formattedString);
        },
        downloadToFile: function(content) { // TXT file download
            var link = document.createElement('a'); // Create element with <a> tag

            const file = new Blob([content], { type: 'text/plain' }); // Create a blob object with the file content which you want to add to the file

            link.href = URL.createObjectURL(file); // Add file content in the object URL


            link.download = "languageCodesChirpRecognizers.txt"; // Add file name

            link.click(); // Add click event to <a> tag to save file.
            URL.revokeObjectURL(link.href); // Remove href link.
        },
        /* END FOR TESTING ONLY */
    },
    watch: {
        showEditUsername (value) {
            value ? this.$nextTick( () => {
                this.$refs.usernameTextInput?.focus();
                // if (this.newUsername.length > 30) {
                //     this.$refs.usernameTextInput?.validate();
                // }
            }) : "";
        },
    },
    computed: {
        isMobile() {
            return this.$store.state.isMobileDevice;
        },
        isDirty() {
            // Don’t compare the File object; compare URL + scalar fields
            // console.log("this.formData: ", this.formData);
            // console.log("this.originalData: ", this.originalData);
            const a = { ...this.formData, /*profilePicture: undefined*/ };
            const b = { ...this.originalData, /*profilePicture: undefined*/ };
            let isEqual = !this.deepEqual(a, b); // || !!this.form.profilePicture;
            // console.log("isDirty: ", isEqual);
            return isEqual;
        },
        // formIsValid() {
        //     if (this.userDataChanged &&)
        // },
        // nameErrors () {
        //     const errors = []
        //     // if (!this.newUsername) return errors
        //     this.newUsername.length > 30 && errors.push('Username must be 30 characters or less');
        //     return errors
        // },
        savedUserData() {
            return this.$store.state.userData;
        },
    },
    beforeDestroy: function() {
        if (this.previewImage) {
            this.$window.URL.revokeObjectURL(this.previewImage);
        }
    },
    beforeRouteLeave(to, from, next) {
        if (this.isSaving) {
            this.$store.commit('alertUser', { show: true, text: "Please wait while we save your settings!", type: 'snackbar' });
        } else if (this.isDirty && !this.isSaving) {
            this.$store.commit('alertUser', { show: true, text: "Save your changes before leaving!", type: 'snackbar' });
        } else {
            next();
        }
        // if (this.isDirty) {
        //     console.log("send to store to update");
        //     this.$store.dispatch('saveUpdatedSettings', this.formData).then(() => { next() }).catch(() => { next() });
        // }
    },
    beforeMount: function(){
        /* copy the local userData var to the savedUserData var from the store. this is so we can change the values */
        this.userData = {
            ... this.savedUserData
        }
        if (typeof this.userData.playbackStyleAudioFirst === "undefined") {
            // console.log("Audio First Mode does not exist in userData, setting to default value of true.");
            this.userData.playbackStyleAudioFirst = true;
        }
        if (typeof this.userData.playbackStyleSameStart === "undefined") {
            // console.log("Same Start Mode does not exist in userData, setting to default value of true.");
            this.userData.playbackStyleSameStart = true;
        }
        if (typeof this.userData.showCaptions === "undefined") {
            // console.log("Show Captions does not exist in userData, setting to default value of true.");
            this.userData.showCaptions = true;
        }
    },
    created: function() {
        if(!this.userData.languageSelected) this.userData.languageSelected = this.languageSelected;

        const u = this.$store.state.userData;
        if (u.darkTheme !== this.$vuetify.theme.dark) this.$vuetify.theme.dark = u.darkTheme;
        this.formData = {
            imageInput: null,
            profilePicture: u.profilePicture || null,
            username: u.username || "",
            darkTheme: u.darkTheme || false,
            languageSelected: u.languageSelected || {
                text: "English (United States)",
                value: "en-US",
            },
            pushToTawq: !!u.pushToTawq,
            // For users who have never saved settings these fields are undefined. Fall through to the
            // canonical defaults (ViewPost CANONICAL_DEFAULTS: continuous, caption audio on, captions on;
            // ViewPost data() defaults sameStart to true) so the form reflects the playback behavior the
            // user actually experiences. `??` preserves an explicitly saved false, unlike the old `!!`.
            playbackStyle: u.playbackStyle ?? SETTINGS_FORM_DEFAULTS.playbackStyle, // canon: continuous
            playbackStyleAudioFirst: !!u.playbackStyleAudioFirst, // pauseplay-only sub-setting; false default unchanged
            playbackStyleSameStart: u.playbackStyleSameStart ?? SETTINGS_FORM_DEFAULTS.playbackStyleSameStart, // canon: skip overlap
            captionAudio: u.captionAudio ?? SETTINGS_FORM_DEFAULTS.captionAudio, // canon: narration audio on
            showCaptions: u.showCaptions ?? SETTINGS_FORM_DEFAULTS.showCaptions, // canon: true
            autoSkipDelay: u.autoSkipDelay || false,
            autoSkipDelayTime: u.autoSkipDelayTime || 2.5,
        }
        this.originalData = JSON.parse(JSON.stringify(this.formData));

        /*** FOR TESTING ONLY ***/
        // const isAdmin = (firebase.auth.currentUser.uid === 'KhZ38UQfssTfNSPuvzj4BSC00rC2' || firebase.auth.currentUser.uid === '9hg1CKOXMFefAWLkUMaBGv7j40u1') ? true : false; // userIds for Scott Brady with account emails: scott.tawq.in@gmail.com and bradyscottmorris@gmail.com respectively
        // if (isAdmin) {
        //     // this.extractLanguageCodesBasedOnModelAndLocation();
        //     // this.unlinkGoogleAccount(); // this will unlink a google account and is used for testing so we can sign up with a google account again.
        //     // this.sortEmails();
        //     // this.moveDocument();
        //     // this.getAllPosts(); // used to get all public posts
        //     // this.createUserDataInFirebaseFirestore();
        // }
        // this.getAudio(); // used for testing!!!
        /*** END FOR TESTING ONLY ***/
    },
};
</script>

<style scoped>
.theme-icon {
    transform: rotate(180deg);
}

.username-wrap {
    display: inline-flex;
    align-items: center;       /* vertically center text + icon */
    justify-content: center;   /* center the whole group in the col */
    cursor: pointer;
    max-width: 100%;
    min-width: 0;
}

.username-text {
    flex: 1 1 auto;            /* let text take remaining space */
    min-width: 0;              /* REQUIRED for ellipsis in flex */
    overflow: hidden;          /* hide overflow */
    text-overflow: ellipsis;   /* show … when too long */
    white-space: nowrap;       /* keep it on one line */
}

.rename-btn {
    flex: 0 0 auto;            /* icon never shrinks/wraps */
}
</style>